import ApiService from './api';

// Price Suggestion API service
class PriceSuggestionService {
  // Get form option lists (known models, conditions, fuel types, etc.)
  static async getOptions() {
    try {
      const response = await ApiService.get('/price-suggestion/options');
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Estimate an approximate price for a vehicle
  static async estimate(payload = {}) {
    try {
      const response = await ApiService.post('/price-suggestion/estimate', payload);
      return response;
    } catch (error) {
      throw error;
    }
  }
}

export default PriceSuggestionService;
